import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_PAYMENTS = "getPaginatedPayments";
export const ALL_PAYMENTS = "getAllPayments";
export const CREATE_PAYMENT_FORM = "createPaymentForm";
export const DELETE_PAYMENT = "deletePayment";
export const GET_PAYMENT_DATA = "getPaymentData";
export const CREATE_PAYMENT = "createPayment";
export const UPDATE_PAYMENT = "updatePayment";


// mutation types

export const SET_PAGINATED_PAYMENTS = "setPaginatedPayments";
export const SET_ALL_PAYMENTS = "setAllPayments";
export const SET_PAYMENT_DATA = "setPaymentData";
export const SET_PAYMENT_META = "setPaymentMeta";
export const SET_PAYMENT_ERROR = "setPaymentError";
export const SET_PAYMENT_LOADING = "setPaymentLoading";
export const CLEAR_PAYMENT_ERROR = "clearPaymentError";
export const SET_IS_DISABLED_PAYMENT = "setIsDisabledPayment";


const state = {
    payments: [],
    paginatedPayments: [],
    payment_data: {},
    meta_payment : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPayments(state) {
        return state.paginatedPayments;
    },

    allPayments(state) {
        return state.payments;
    },

    getPaymentData(state) {
        return state.payment_data;
    },

    meta_payment(state) {
        return state.meta_payment;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_PAYMENTS](context, payload) {
        context.commit(SET_IS_DISABLED_PAYMENT, false);
        context.commit(SET_PAYMENT_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/payments?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PAYMENT_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_PAYMENTS, data);
                context.commit(SET_PAYMENT_META, data);
                context.commit(SET_PAYMENT_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_PAYMENT_LOADING, false);
            context.commit(SET_PAYMENT_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_PAYMENTS]() {
        return new Promise(resolve => {
            ApiService.get('/paymentsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_PAYMENT_FORM](context) {
        context.commit(SET_PAYMENT_LOADING, false);
        context.commit(SET_PAYMENT_ERROR, false);
        context.commit(SET_IS_DISABLED_PAYMENT, false);
    },

    [GET_PAYMENT_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_PAYMENT, true);
        context.commit(SET_PAYMENT_LOADING, true);
        context.commit(CLEAR_PAYMENT_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/payment/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PAYMENT_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PAYMENT_DATA, response.data);
                    context.commit(SET_PAYMENT_LOADING, false);
                    context.commit(SET_IS_DISABLED_PAYMENT, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PAYMENT_LOADING, false);
                context.commit(SET_PAYMENT_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PAYMENT, true);
            });
        });
    },

    [CREATE_PAYMENT](context, payload) {
        context.commit(SET_PAYMENT_LOADING, false);
        context.commit(SET_IS_DISABLED_PAYMENT, true);
        context.commit(CLEAR_PAYMENT_ERROR);
        return ApiService.post("/payment/handleHashRequest", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PAYMENT_ERROR);
            }
            else{
                context.commit(SET_PAYMENT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Parametre başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_PAYMENT_ERROR);
                context.commit(SET_IS_DISABLED_PAYMENT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PAYMENT_LOADING, false);
            context.commit(SET_PAYMENT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PAYMENT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_PAYMENT](context, payload) {
        context.commit(SET_PAYMENT_LOADING, true);
        context.commit(SET_IS_DISABLED_PAYMENT, true);
        context.commit(CLEAR_PAYMENT_ERROR);
        
        return ApiService.put(`/payment/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PAYMENT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı parametre başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PAYMENT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PAYMENT_LOADING, false);
            context.commit(SET_PAYMENT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PAYMENT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_PAYMENT](context, payload) {
        context.commit(SET_PAYMENT_LOADING, true);
        context.commit(CLEAR_PAYMENT_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/payment/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_PAYMENT_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı parametre başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_PAYMENT_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_PAYMENTS](state, paginatedPayments) {
        state.paginatedPayments = paginatedPayments.data;
    },

    [SET_ALL_PAYMENTS](state, payments) {
        state.payments = payments;
    },

    [SET_PAYMENT_DATA](state, payments_data) {
        state.payments_data = payments_data;
        state.errors = [];
    },

    [SET_PAYMENT_META](state, meta_payment) {
        state.meta_payment = meta_payment;
    },

    [SET_PAYMENT_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PAYMENT_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PAYMENT_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PAYMENT](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
